<template>
  <div id="coupon-detail-dialog" class="custom-modal">
    <div class="modal-body" v-if="couponDetail">
      <div class="coupon-detail-head">
        <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.couponCode") }}</div>
        <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.limitUsage") }}</div>
        <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.remainder") }}</div>
        <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.quickLink") }}</div>
      </div>
      <div class="coupon-detail-item" :key="couponKey">
        <div class="item" v-for="(item, index) in couponDetail.codes" :key="index">
          <div class="code">
            <span @click="goPaymentFilter(item.code)">{{ item.code }}</span>
            <el-tooltip placement="top" :content="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.copyCode')">
              <i class="fas fa-copy" v-clipboard:copy="item.code" v-clipboard:success="copyCodeSuccess" :key="couponCounter"></i>
            </el-tooltip>
          </div>
          <div>{{ couponDetail.limitPerCoupon }} / {{ item.usage }}</div>
          <div>{{ couponDetail.limitPerCoupon - item.usage }}</div>
          <div v-clipboard:copy="item.link" v-clipboard:success="copySuccess" :key="couponCounter" class="cursor-pointer text-info text-underline">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.copyLink") }}</div>
        </div>
      </div>
    </div>
    <div class="modal-footer" slot="footer" v-if="couponDetail">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.close") }}</el-button>
      </div>
      <div class="center-buttons">
        <el-pagination layout="sizes,prev, pager, next" :current-page.sync="filter.page" @size-change="handleSizeChange" @current-change="getCouponDetail" :page-size="filter.take" :total="couponDetail.count" :page-sizes="[20, 30, 40, 50]"></el-pagination>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="exportPdf">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.download") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegistrationCouponDetails",
  props: ["id"],
  data() {
    return {
      couponCounter: +new Date(),
      couponKey: +new Date(),

      filter: {
        page: 1,
        take: 20,
        skip: 0
      },
      couponDetail: null
    };
  },
  async mounted() {
    await this.getCouponDetail();
  },
  methods: {
    goPaymentFilter(code) {
      this.$store.state.payments.filter.couponCode = code;
      this.$router.push({ path: "payments" });
    },
    copySuccess() {
      this.$message.success(this.$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.copyLinkMsg'));
      this.couponCounter += 1;
    },
    copyCodeSuccess() {
      this.$message.success(this.$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.registrationCouponDetails.copyCodeMsg'));
      this.couponCounter += 1;
    },
    exportPdf() {
      this.exportXlsx(2, this.id, null);
    },
    // async filtered() {
    //   var dammyCodes = JSON.parse(JSON.stringify(this.couponDetail));
    //   this.filter.skip = (this.filter.page - 1) * this.filter.take;
    //   this.currentCodes = JSON.parse(JSON.stringify(dammyCodes.codes.splice(this.filter.skip, this.filter.take + this.filter.skip)));
    // },
    handleSizeChange(take) {
      this.filter.take = take;
    },
    async getCouponDetail() {
      var skip = (this.filter.page - 1) * this.filter.take;
      var take = this.filter.take + this.filter.skip;
      var payload = {
        id: this.id,
        take: take,
        skip: skip
      };
      var res = await this.$store.dispatch("getCouponGroup", { id: this.id, ...payload });
      this.couponDetail = res.data.data.item;
    }
  },
  beforeDestroy() {
    this.currentCodes = [];
  },
  watch: {
    async id() {
      await this.getCouponDetail();
    },
    filter: {
      deep: true,
      async handler() {
        await this.getCouponDetail();
        this.couponKey += 1;
      }
    }
  }
};
</script>

<style lang="less">
.coupon-detail-head {
  display: grid;
  grid-template-columns: 1fr 120px 90px 120px;
  padding: 10px;
  margin-top: 1rem;
  background-color: #eaeaea;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
  font-weight: bold;
}

.coupon-detail-item {
  .item {
    display: grid;
    grid-template-columns: 1fr 120px 90px 120px;
    padding: 10px;
    margin-bottom: 0.5rem;
    align-items: center;
    border-radius: 8px;
    background-color: #f3f3f3;
    transition: all 0.5s;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    .code {
      display: flex;
      gap: 5px;
      align-items: center;
      span {
        text-decoration: underline;
        font-weight: bold;
        color: #03658c;
        cursor: pointer;
      }
      i {
        cursor: pointer;
      }
    }
    gap: 0.5rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      i.burger {
        &.me {
          color: #ccc;
        }
        font-size: 20px;
      }
      & > i.el-icon-loading {
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/RegistrationCouponDetails.vue